
/** 混入方法 :::
 *  @mixin mixDomainManager 模块管理者混入
 *  @mixin mixFormNodeManager 标单项节点管理者混入
 *  @mixin mixMakeConfigManager 生成配置管理者混入
 *  @mixin mixNodeActionManager 标单项事件管理者混入
 *  @mixin mixEventConfigManager 事件配置管理者混入
 *  @mixin mixRicePreviewBridgeCommon 联动预览组件公共部分混入
 *  @mixin mixPreviewItemTemplateProtocolRealize 预览表单项协议实现
 *  @mixin mixPreviewItemTemplateProtocolRealize 渲染表单项协议实现
 */
import { mixDomainManager } from "@/mixins/common/mix_domain_manager.js"
import { mixFormNodeManager } from "@/mixins/common/mix_form_node_manager.js";
import { mixMakeConfigManager } from "@/mixins/common/mix_make_config_manager.js";
import { mixNodeActionManager } from "@/mixins/common/mix_node_action_manager.js";
import { mixEventConfigManager } from "@/mixins/common/mix_event_config_manager.js";
import { mixPreviewItemTemplateProtocolRealize, mixRenderItemTemplateProtocolRealize } from "@/mixins/rice_preview_bridge/mix_rice_preview_bridge_protocol_realize.js"
/** 工具方法 :::
 *  @function makeComputedGroup 生成计算属性组方法
 */
import { makeComputedGroup } from "@/utils/computed_utils.js";


/** @name RicePreviewBridge.vue 混入
 *  @author liuguisheng
 *  @version 2019-09-26
 */
export const mixRicePreviewBridgeStore = {
  mixins: [
    mixDomainManager,
    mixFormNodeManager,
    mixMakeConfigManager, 
    mixNodeActionManager,
    mixEventConfigManager,
    mixPreviewItemTemplateProtocolRealize,
    mixRenderItemTemplateProtocolRealize,
  ],
  provide() {
    return {
      mix_rice_preview_bridge_store: this.mix_rice_preview_bridge_store
    }
  },
  data() {
    return {
      /** mix_rice_preview_bridge_store 属性说明 ::: 
       *  - domainList: 模块组件集合
       *  - formList: 预览表单项集合
       *  - formSettingState: 表单属性设置集合
       *  - formMap: 表单项字典
       *  - eventMap: 事件配置字典
       *  - variableMap: 变量字典
       *  - formModels: 表单变量
       */
      mix_rice_preview_bridge_store: {
        domainList: [],
        formList: [],
        formSettingState: { componentSize: 'mini' },
        formMap: {},
        eventMap: {},
        variableMap: {},
        formModels: {},
      }
    }
  },
  computed: {
    /** 计算属性说明 ::: 
     *  @return {Array<Object>} domainList 模块组件列表
     *  @return {Array<Object>} formList 预览表单项列表
     *  @return {Object} formSettingState 预览表单样式配置
     *  @return {Object} formMap 表单项字典
     *  @return {Object} eventMap 事件配置字典
     *  @return {Object} variableMap 变量设置字典
     *  @return {Object} formModels 表单数据
     */
    ...makeComputedGroup("mix_rice_preview_bridge_store", {
      domainList: "domainList",
      formList: "formList",
      formSettingState: "formSettingState",
      formMap: "formMap",
      eventMap: "eventMap",
      variableMap: "variableMap",
      formModels: "formModels",
    }),
  },
  methods: {
    /** @name 导入模板配置
     *  @param {Object} templateConfig 模板配置数据
     *  @return {Boolean} 操作结果
     *  @author 王汝鹏
     *  @version 2020-01-13 
     */
    importTemplateConfig(templateConfig) {
      // 更新数据到store中
      let { itemManage='group', domainList=[], formList=[], formMap={}, eventMap={}, variableMap={} } = templateConfig;
      this.itemManage = itemManage;
      this.formMap = formMap;
      this.domainList = domainList;
      this.formList = formList;
      this.eventMap = eventMap;
      this.variableMap = variableMap;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/rice_preview_bridge/mix_rice_preview_bridge.js